import axios from '../../utils/axiosConfig';
import config from '../../utils/Config';

let getdistrictPageData = (countyId) => {
    
    console.log(countyId)
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'district/getalldistrict/'+countyId).then(result => {
            resolve(result)
        }).catch((err) => {

            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch district data"
                })
            }
        })
    })
}

const addNewdistrict = async (districtData) => {
    return new Promise((resolve, reject) => {
        axios.post(config.basePath + 'district/adddistrict', districtData).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch district data"
                })
            }
        })
    })

}

const editUpdateddistrict = async (districtData) => {
    console.log("districtData :" +districtData.districtId)
    return new Promise((resolve, reject) => {
        axios.put(config.basePath + 'district/editdistrict/'+ districtData.districtId, districtData).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch report data"
                })
            }
        })
    })

}

const deletedistrict = async (districtID) => {
    return new Promise((resolve, reject) => {
        axios.get(config.basePath + 'district/deletedistrict/'+ districtID).then((result) => {
            resolve(result)
        }).catch((err) => {
            if (err && err.response && err.response.data && err.response.data && err.response.data.message) {
                reject({
                    message: err.response.data.message
                })
            } else {
                reject({
                    message: "Unable to fetch district data"
                })
            }
        })
    })

}

const districtService = {
    getdistrictPageData,
    addNewdistrict,
    editUpdateddistrict,
    deletedistrict
}

export default districtService 